"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeStructureComponent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const TypeUtils_1 = require("../../../common/TypeParsing/TypeUtils");
const Input_1 = require("./Input");
const Form_1 = require("./Form");
const HashMatrix_1 = __importDefault(require("./ValueProcessing/HashMatrix"));
const Layout_1 = require("./Layout");
const styled_components_1 = __importStar(require("styled-components"));
const HelperTypes_1 = require("./HelperTypes");
const LayoutForm = (0, styled_components_1.default)(Form_1.Form) `
  ${(p) => (0, Layout_1.getLayoutContainerCSS)(p)}
`;
const OpenFormButtonBase = styled_components_1.default.button `
  ${(p) => p.$gridArea
    ? (0, styled_components_1.css) `
          grid-area: ${p.$gridArea};
        `
    : ""}
`;
const OpenFormButton = ({ disabled = false, name, label, onOpenForm, }) => {
    const onOpenFormInternal = (0, react_1.useCallback)(() => {
        onOpenForm(name);
    }, [name, onOpenForm]);
    return ((0, jsx_runtime_1.jsxs)(OpenFormButtonBase, { disabled: disabled, type: "button", "$gridArea": name, onClick: onOpenFormInternal, children: ["Edit ", label] }));
};
/**
 * Automatically generate a complex, nested set of form views from a type structure map.
 *
 * @see {@link convertTypeScriptToTypeStructureMap}
 * */
const TypeStructureComponent = ({ typeStructureMap, typeStructure, value, onChange, onNavigateToPath, onNavigateBack, navigationPathPrefix = [], topLevel = false, isEntryPoint = false, }) => {
    const baseTypeStructure = (0, react_1.useMemo)(() => {
        const { type: typeStructureType = "" } = typeStructure;
        const topLevelTypeStructure = (0, TypeUtils_1.getTypeStructureByName)(typeStructureType, typeStructureMap);
        return Object.assign(Object.assign({}, topLevelTypeStructure), typeStructure);
    }, [typeStructureMap, typeStructure]);
    const isForm = (0, react_1.useMemo)(() => {
        const { content = [] } = baseTypeStructure;
        return content.length > 0;
    }, [baseTypeStructure]);
    const cleanTypeStructure = (0, react_1.useMemo)(() => {
        const { contentNames } = baseTypeStructure;
        return (0, TypeUtils_1.getTypeStructureWithFilteredContent)(contentNames, baseTypeStructure);
    }, [baseTypeStructure]);
    const { name: typeStructureName = "", type: typeStructureType, content: typeStructureContent = [], readonly = false, } = cleanTypeStructure;
    const { [TypeUtils_1.TAG_TYPES.label]: typeStructureLabel = undefined, [TypeUtils_1.TAG_TYPES.layout]: typeStructureLayout = undefined, [TypeUtils_1.TAG_TYPES.options]: typeStructureOptionsString = undefined, [TypeUtils_1.TAG_TYPES.optionsType]: typeStructureOptionsTypeName = undefined, [TypeUtils_1.TAG_TYPES.allowCustomValue]: typeStructureAllowCustomValue = undefined, } = (0, react_1.useMemo)(() => (0, TypeUtils_1.getTagValues)([
        TypeUtils_1.TAG_TYPES.label,
        TypeUtils_1.TAG_TYPES.inline,
        TypeUtils_1.TAG_TYPES.layout,
        TypeUtils_1.TAG_TYPES.options,
        TypeUtils_1.TAG_TYPES.optionsType,
        TypeUtils_1.TAG_TYPES.allowCustomValue,
    ], cleanTypeStructure), [cleanTypeStructure]);
    const typeStructureOptions = (0, react_1.useMemo)(() => {
        if (typeof typeStructureOptionsString === "string") {
            return (typeStructureOptionsString
                .split("\n")
                .map((l) => l.split(","))
                // @ts-ignore
                .flat()
                .map((l) => l.trim()));
        }
        else {
            return typeStructureOptionsTypeName &&
                typeof typeStructureOptionsTypeName === "string"
                ? (0, TypeUtils_1.getTypeStructureByName)(typeStructureOptionsTypeName, typeStructureMap)
                : undefined;
        }
    }, [
        typeStructureOptionsString,
        typeStructureOptionsTypeName,
        typeStructureMap,
    ]);
    const hasTypeStructureLayout = (0, react_1.useMemo)(() => typeof typeStructureLayout === "string", [typeStructureLayout]);
    const [internalValueBase, setInternalValue] = (0, react_1.useState)(value);
    const valueLastChanged = (0, react_1.useMemo)(() => new Date().getTime(), [value]);
    const internalValueLastChanged = (0, react_1.useMemo)(() => new Date().getTime(), [internalValueBase]);
    const internalValue = (0, react_1.useMemo)(() => valueLastChanged > internalValueLastChanged ? value : internalValueBase, [value, internalValueBase, valueLastChanged, internalValueLastChanged]);
    const hasChanges = (0, react_1.useMemo)(() => internalValue !== value, [internalValue, value]);
    const submissionTypeName = (0, react_1.useMemo)(() => {
        return topLevel ? "" : typeStructureName;
    }, [topLevel, typeStructureName]);
    const onFormSubmit = (0, react_1.useCallback)(() => {
        onChange(submissionTypeName, internalValue);
        if (onNavigateBack) {
            onNavigateBack();
        }
    }, [topLevel, submissionTypeName, internalValue, onNavigateBack]);
    const onResetForm = (0, react_1.useCallback)(() => {
        setInternalValue(value);
    }, [value]);
    const onCancelForm = (0, react_1.useCallback)(() => {
        if (onNavigateBack) {
            onNavigateBack();
        }
    }, [onNavigateBack]);
    const onPrimitiveChangeInternal = (0, react_1.useCallback)((_n, v) => {
        setInternalValue(v);
    }, [setInternalValue]);
    const onPropertyChange = (0, react_1.useCallback)((n, v) => {
        const newValue = Object.assign(Object.assign({}, internalValue), { [n]: v });
        setInternalValue(newValue);
        if (!topLevel || isEntryPoint) {
            onChange(submissionTypeName, newValue);
        }
    }, [
        internalValue,
        setInternalValue,
        topLevel,
        isEntryPoint,
        onChange,
        submissionTypeName,
    ]);
    const onNavigateToPathInternal = (0, react_1.useCallback)((path = []) => {
        if (onNavigateToPath) {
            const targetValue = new HashMatrix_1.default({
                hashMatrix: internalValue,
            }).getPath(path);
            const targetTypeStructure = (0, TypeUtils_1.getTypeStructureByPath)(path, cleanTypeStructure, typeStructureMap);
            const { multiple: ttsMultiple } = targetTypeStructure;
            const targetLabel = (0, TypeUtils_1.getTagValue)(TypeUtils_1.TAG_TYPES.label, targetTypeStructure);
            const cleanTargetLabel = typeof targetLabel === "string" ? targetLabel : "";
            onNavigateToPath({
                label: ttsMultiple
                    ? cleanTargetLabel
                    : (0, TypeUtils_1.getValueLabel)(targetValue, targetTypeStructure, typeStructureMap),
                path: [...navigationPathPrefix, ...path],
            });
        }
    }, [
        onNavigateToPath,
        navigationPathPrefix,
        internalValue,
        cleanTypeStructure,
        typeStructureMap,
    ]);
    const onOpenForm = (0, react_1.useCallback)((name) => {
        onNavigateToPathInternal([name]);
    }, [onNavigateToPathInternal]);
    const FormComp = topLevel ? LayoutForm : Layout_1.LayoutBox;
    const formProps = (0, react_1.useMemo)(() => {
        return Object.assign(Object.assign({}, (topLevel ? { onSubmit: onFormSubmit } : {})), { $gridArea: !topLevel ? typeStructureName : undefined });
    }, [topLevel, onFormSubmit, topLevel, typeStructureName]);
    const layoutBoxProps = (0, react_1.useMemo)(() => {
        return {
            $isGrid: hasTypeStructureLayout,
            $gridTemplate: (0, Layout_1.getTypeStructureLayoutGridTemplate)(typeStructureLayout, topLevel),
        };
    }, [hasTypeStructureLayout, typeStructureLayout, topLevel]);
    const controls = (0, react_1.useMemo)(() => {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [topLevel && !isEntryPoint && hasChanges ? ((0, jsx_runtime_1.jsxs)(Layout_1.LayoutControls, { children: [(0, jsx_runtime_1.jsx)("button", { style: {
                                flex: "1 0 auto",
                                width: "auto",
                            }, type: "button", onClick: onCancelForm, children: "Cancel" }), (0, jsx_runtime_1.jsx)("button", { style: {
                                flex: "1 0 auto",
                                width: "auto",
                            }, type: "button", onClick: onResetForm, children: "Reset" }), (0, jsx_runtime_1.jsx)("button", { style: {
                                flex: "1 0 auto",
                                width: "auto",
                            }, type: "submit", children: "Submit" })] })) : undefined, topLevel && !isEntryPoint && !hasChanges ? ((0, jsx_runtime_1.jsx)(Layout_1.LayoutControls, { children: (0, jsx_runtime_1.jsx)("button", { style: {
                            flex: "1 0 auto",
                            width: "auto",
                        }, type: "button", onClick: onCancelForm, children: "Done" }) })) : undefined] }));
    }, [
        topLevel,
        isEntryPoint,
        hasChanges,
        onCancelForm,
        onResetForm,
        onFormSubmit,
    ]);
    if (isForm) {
        return ((0, jsx_runtime_1.jsxs)(FormComp, Object.assign({}, formProps, { "$allowShrink": topLevel, children: [(0, jsx_runtime_1.jsx)(Layout_1.LayoutBox, { "$allowShrink": topLevel, children: (0, jsx_runtime_1.jsx)(Layout_1.LayoutBox, Object.assign({}, layoutBoxProps, { "$allowShrink": false, children: typeStructureContent.map((tS) => {
                            const { name: tSName, literal: tSLiteral = false, type: tSType, multiple: tSMultiple, } = tS;
                            const { [TypeUtils_1.TAG_TYPES.inline]: tSInline, [TypeUtils_1.TAG_TYPES.label]: tSLabel, } = (0, TypeUtils_1.getTagValues)([TypeUtils_1.TAG_TYPES.inline, TypeUtils_1.TAG_TYPES.label], tS);
                            const inputLabel = typeof tSLabel === "string" ? tSLabel : tSName;
                            const tSTypeIsTypeStructure = typeof tSType === "string" && !!typeStructureMap[tSType];
                            const useInputType = !tSTypeIsTypeStructure;
                            const isHelperType = tSType in HelperTypes_1.DataTypeMap;
                            if (!tSMultiple &&
                                (isHelperType || tSLiteral || tSInline || useInputType)) {
                                return ((0, jsx_runtime_1.jsx)(exports.TypeStructureComponent, { typeStructureMap: typeStructureMap, typeStructure: tS, value: internalValue === null || internalValue === void 0 ? void 0 : internalValue[tSName], onChange: onPropertyChange, onNavigateToPath: onNavigateToPath, navigationPathPrefix: [tSName] }, tSName));
                            }
                            else {
                                return ((0, jsx_runtime_1.jsx)(OpenFormButton, { disabled: hasChanges, name: tSName, label: inputLabel, onOpenForm: onOpenForm }, tSName));
                            }
                        }) })) }), controls] })));
    }
    else {
        const inputComp = ((0, jsx_runtime_1.jsx)(Input_1.Input, { name: typeStructureName, label: `${typeStructureLabel !== null && typeStructureLabel !== void 0 ? typeStructureLabel : ""}`, value: topLevel ? internalValue : value, type: typeStructureType, onChange: topLevel ? onPrimitiveChangeInternal : onChange, options: typeStructureOptions, allowCustomValue: !!typeStructureAllowCustomValue, readonly: readonly }, typeStructureName));
        return topLevel ? ((0, jsx_runtime_1.jsxs)(LayoutForm, { "$allowShrink": false, onSubmit: onFormSubmit, children: [inputComp, controls] })) : (inputComp);
    }
};
exports.TypeStructureComponent = TypeStructureComponent;
